/**
 * Preferences observed by the local storage
 *
 * @description - preferences for the list-view component can be stored in local storage and remembered when the component is loaded.
 *
 * @type {{in_alarm: boolean, has_devices: boolean, sort_by: string}}
 */
const listPreferences = {
  has_devices: false,
  in_alarm: false,
  sort_by: 'DESC',
};

/**
 * Dashboard Location ID
 *
 * @type {null}
 */
const dashboardLocation = null;

/**
 * Set the location ID when changed in the dashboard
 *
 */
function storeDashboardLocation() {
  localStorage.setItem('dashLocation', dashboardLocation);
}

/**
 * Return the dashboard ID if exists
 *
 * @returns {number}
 */
function retrieveDashboardLocation() {
  return parseInt(localStorage.getItem('dashLocation'), 10);
}

/**
 * Graph View Storage
 *
 * @description - store the last device selected in the graph view
 * @type {{location: null, device: null, group: null}}
 */
const graphView = {};

/**
 * Store the last device set in the graph view
 */
function storeGraphView() {
  localStorage.setItem('graphView', JSON.stringify(graphView));
}

/**
 * Retrieve Graph view
 *
 * @description - retrieve stored graph view settings
 * @returns {{location, device, group, selectedEvents: null}}
 */
function retrieveGraphView() {
  const savedDevice = JSON.parse(localStorage.getItem('graphView'));
  if (savedDevice) {
    return {
      location: savedDevice.location,
      group: savedDevice.group,
      device: savedDevice.device,
      task: savedDevice.task,
      period: savedDevice.period,
      date: savedDevice.date || null,
      loadBy: savedDevice.loadBy,
      selectedEvents: savedDevice.selectedEvents ?? null,
    };
  }
  return {
    // location: null,
    // group: null,
    // device: null,
    // task: null,
    // period: null,
    // date: null,
    // loadBy: null,
  };
}

function clearGraphView() {
  graphView.location = null;
  graphView.group = null;
  graphView.device = null;
  graphView.task = null;
  graphView.period = null;
  graphView.date = null;
  graphView.loadBy = null;
  graphView.selectedEvents = null;
  storeGraphView();
}

/**
 * Store the users preferences in local storage
 */
function storePreferences() {
  localStorage.setItem('listPreferences', JSON.stringify(listPreferences));
}

/**
 * Export
 */
export {
  listPreferences,
  graphView,
  dashboardLocation,
  storeGraphView,
  storePreferences,
  retrieveGraphView,
  clearGraphView,
  storeDashboardLocation,
  retrieveDashboardLocation,
};
